import mark from '../assets/image-orange.png';
import wordmark from '../assets/text-orange.png';
import './BrandLogo.css';

export default function BrandLogo() {
  return <span className="brand-logo" role="img" aria-label="G-Unit Fitness">
    <img className="brand-logo__mark" src={mark} width="575" height="591" alt="" />
    <img className="brand-logo__wordmark" src={wordmark} width="1322" height="116" alt="" />
  </span>;
}
